import css from 'styled-jsx/css';

const styles = css.global`#boleto-dda {
  background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
  padding: 48px 0 136px;
  position: relative;
}

#boleto-dda .ctn-home-24 {
  z-index: 9;
  position: relative;
}

#boleto-dda .boleto-dda-titulo {
  color:  #FFF;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
}

#boleto-dda .boleto-dda-subtitulo {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  margin-top: 24px;
}

#boleto-dda .boleto-dda-cards {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

#boleto-dda .boleto-dda-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#boleto-dda .boleto-dda-card .boleto-dda-card-img {
  width: 40px;
}

#boleto-dda .boleto-dda-card .boleto-dda-card-text {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}

#boleto-dda .btn-saiba-mais-dda {
  width: 272px;
  height: 48px;
  margin: 32px auto 0;
}

#boleto-dda .img-dda {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  mix-blend-mode: multiply;
}

#boleto-dda .img-dda-desk {
  display: none;
  mix-blend-mode: multiply;
}

@media (min-width: 992px) {
  #boleto-dda {
    background: linear-gradient(88deg, #600 -1.54%, #970000 23.92%, #C00 102.37%);
    padding: 40px 0;
    margin-bottom: 88px;
  }

  #boleto-dda .boleto-dda-titulo {
    font-size: 56px;
  }

  #boleto-dda .boleto-dda-cards {
    flex-direction: row;
    margin-top: 48px;
  }

  #boleto-dda .boleto-dda-card {
    width: 273px;
  }

  #boleto-dda .btn-saiba-mais-dda {
    margin: 48px 0 0;
  }

  #boleto-dda .img-dda {
    display: none;
  }

  #boleto-dda .img-dda-desk {
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}`;

export default styles;